import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/auth.models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
};

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getUsersByTenant(): Observable<any> {    
        return this.http.get(
            `${environment.apiBaseAddress}User`, 
            httpOptions
        );
    }

    getUserById(userId): Observable<any> {    
        return this.http.get(
            `${environment.apiBaseAddress}User/${userId}`, 
            httpOptions
        );
    }

    updateUser(userId, user): Observable<any> {
        return this.http.put(
            `${environment.apiBaseAddress}User/${userId}`,
            user, 
            httpOptions
        );
    }
}
